// extracted by mini-css-extract-plugin
export default {"component":"ColorMenu_component__N5j0y","colorsContainer":"ColorMenu_colorsContainer__S8xcm"};